import AdminDashboard from './admin/AdminDashboard';

// Admin entry point
export default function Admin() {
  return <AdminDashboard />;
}